/* TT-PAY-MODAL — upgrades the footer's "Payment & installments" link into a
   panel. Josh, 2026-08-21: "That should be a pop up modal window."

   IT IS AN UPGRADE, NOT A REPLACEMENT. The trigger stays a real
   <a href="/pages/payment-installments"> and that page stays published and
   complete, so with this script dead — or before it parses — the link still
   goes somewhere that answers the question. Same contract as the search
   trigger in sections/tt-header.liquid.

   A MODIFIED CLICK IS NOT A REQUEST FOR A PANEL. Ctrl/Cmd/middle-click means
   "open this in a tab", and swallowing that would take a working browser
   behaviour away from someone who was using it deliberately. */
(function () {
  'use strict';

  var modal, panel, opener;

  function open(ev) {
    if (!modal) return;
    if (ev && (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey || ev.button === 1)) return;
    if (ev) ev.preventDefault();
    opener = ev && ev.currentTarget ? ev.currentTarget : null;

    modal.hidden = false;
    /* One frame between un-hiding and the class, or the transition has nothing
       to run from — the element goes straight to its open state. */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { modal.classList.add('is-open'); });
    });
    document.body.style.overflow = 'hidden';

    var close = modal.querySelector('[data-pay-close]');
    if (close && close.focus) close.focus();
  }

  function shut() {
    if (!modal || modal.hidden) return;
    modal.classList.remove('is-open');
    document.body.style.overflow = '';

    /* Hidden only after the transition, so it fades rather than vanishing.
       `once` so a fast open/close/open cannot stack listeners. */
    var done = function () { modal.hidden = true; };
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      done();
    } else {
      panel.addEventListener('transitionend', done, { once: true });
      /* A belt for the case where no transition runs at all — a hidden tab, or
         a browser that skipped it. Without this the panel stays in the DOM
         catching clicks on the page behind it. */
      setTimeout(done, 400);
    }

    if (opener && opener.focus) opener.focus();
    opener = null;
  }

  function boot() {
    modal = document.getElementById('tt-pay-modal');
    if (!modal) return;
    panel = modal.querySelector('.tt-pay__panel');
    if (!panel) return;

    document.querySelectorAll('[data-pay-open]').forEach(function (el) {
      el.addEventListener('click', open);
    });

    modal.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-pay-close]')) { ev.preventDefault(); shut(); }
    });

    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && !modal.hidden) shut();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
